import React, { forwardRef } from 'react';
import { AutoComplete } from '@progress/kendo-react-dropdowns';

/**
 * @typedef {React.PropsWithoutRef<AutoComplete>} TelerikAutoCompleteProps
 *
 * @param {TelerikAutoCompleteProps} props Component props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseAutoComplete = ({ readOnly, ...props }, ref) => {
  if (readOnly) {
    return (
      <div className="read-only">
        {props.value}
      </div>
    );
  }
  return <AutoComplete ref={ref} {...props} />;
};

/**
 * A base autocomplete component with various options and handlers.
 *
 * @param {TelerikAutoCompleteProps} props Component props. Extends Telerik AutoComplete props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const ForwardAutoComplete = forwardRef(BaseAutoComplete);

export default ForwardAutoComplete;
